module.exports = "pegasus_template/assets/blocks/tile-layout-19.png";